import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { fetchLabels, deleteLabel } from '../../../api/labels';
import { fetchAllLabels, filterLabels, labelStatus, labelStatusText } from '../../../utils/labelSearch';
const EMPTY_FILTERS={keyword:'',status:'all',dateFrom:'',dateTo:''};
const PAGE_SIZE=10;
export function useLabelList() {
  const [allLabels,setAllLabels]=useState([]);
  const [isLoading,setIsLoading]=useState(false);
  const [isDeleting,setIsDeleting]=useState(false);
  const deleting=useRef(false);
  const [error,setError]=useState(null);
  const [filters,setFilters]=useState(EMPTY_FILTERS);
  const [pageNum,setPageNum]=useState(1);
  const requestId=useRef(0);
  const loadAll=useCallback(async()=>{
    const id=++requestId.current;
    setIsLoading(true);setError(null);setAllLabels([]);
    try {
      const complete=await fetchAllLabels(fetchLabels,()=>id===requestId.current);
      if (complete && id===requestId.current) setAllLabels(complete);
    } catch (err) {
      if (id===requestId.current) setError(err.message || '加载标签列表失败');
    } finally {
      if (id===requestId.current) setIsLoading(false);
    }
  },[]);
  useEffect(()=>{loadAll();return()=>{requestId.current+=1;};},[loadAll]);
  const filtered=useMemo(()=>filterLabels(allLabels,filters),[allLabels,filters]);
  const totalPages=Math.max(1,Math.ceil(filtered.length/PAGE_SIZE));
  const safePage=Math.min(pageNum,totalPages);
  const counts=useMemo(()=>{
    const result={all:allLabels.length,published:0,draft:0};
    allLabels.forEach(label=>{const key=labelStatus(label);result[key]=(result[key] || 0)+1;});return result;
  },[allLabels]);
  const statusOptions=useMemo(()=>Object.keys(counts).filter(key=>key!=='all' && (counts[key] || ['published','draft'].includes(key))).map(value=>({value,label:labelStatusText(value),count:counts[value]})),[counts]);
  const updateFilters=useCallback(patch=>{setFilters(old=>({...old,...patch}));setPageNum(1);},[]);
  const resetFilters=useCallback(()=>{setFilters(EMPTY_FILTERS);setPageNum(1);},[]);
  const handleDelete=useCallback(async id=>{
    if (deleting.current || !window.confirm('确定要删除这个标签吗？删除后无法恢复。')) return false;
    deleting.current=true;setIsDeleting(true);
    try {await deleteLabel(id);await loadAll();return true;}
    catch (err) {setError(err.message || '删除标签失败');return false;}
    finally {deleting.current=false;setIsDeleting(false);}
  },[loadAll]);
  return {
    labels:filtered.slice((safePage-1)*PAGE_SIZE,safePage*PAGE_SIZE),isLoading:isLoading || isDeleting,error,
    pagination:{pageNum:safePage,pageSize:PAGE_SIZE,total:filtered.length,totalPages},
    loadLabels:loadAll,handleDelete,changePage:next=>setPageNum(Math.max(1,next)),refresh:loadAll,
    filters,updateFilters,resetFilters,hasActiveFilter:Boolean(filters.keyword || filters.status!=='all' || filters.dateFrom || filters.dateTo),
    counts,statusOptions,totalCount:allLabels.length,
    dateRangeError:filters.dateFrom && filters.dateTo && filters.dateFrom>filters.dateTo ? '更新开始日期不能晚于结束日期。' : '',
  };
}
